import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface KibuClubPopupState {
    isOpen: boolean
    firstShownDate: string | null
    isDismissed: boolean
    showPopup: () => void
    dismissPopup: () => void
    shouldShowPopup: () => boolean
}

const POPUP_DURATION_DAYS = 20
const POPUP_END_DATE = new Date('2025-10-27T23:59:59') // Hard cutoff: October 27th, 2025

const useKibuClubPopupStore = create<KibuClubPopupState>()(
    persist(
        (set, get) => ({
            isOpen: false,
            firstShownDate: null,
            isDismissed: false,

            showPopup: () => {
                const state = get()
                const now = new Date()

                // Don't show if past the end date
                if (now > POPUP_END_DATE) {
                    return
                }

                // Don't show if already dismissed
                if (state.isDismissed) {
                    return
                }

                // Set first shown date if not set
                if (!state.firstShownDate) {
                    set({ firstShownDate: new Date().toISOString(), isOpen: true })
                } else {
                    // Check if 20 days have passed
                    const firstShown = new Date(state.firstShownDate)
                    const daysPassed = (now.getTime() - firstShown.getTime()) / (1000 * 60 * 60 * 24)

                    if (daysPassed < POPUP_DURATION_DAYS) {
                        set({ isOpen: true })
                    }
                }
            },

            dismissPopup: () => {
                set({ isOpen: false, isDismissed: true })
            },

            shouldShowPopup: () => {
                const state = get()
                const now = new Date()

                // Don't show if past the end date
                if (now > POPUP_END_DATE) {
                    return false
                }

                // Don't show if dismissed
                if (state.isDismissed) {
                    return false
                }

                // Show if never shown before
                if (!state.firstShownDate) {
                    return true
                }

                // Check if within 20 day window
                const firstShown = new Date(state.firstShownDate)
                const daysPassed = (now.getTime() - firstShown.getTime()) / (1000 * 60 * 60 * 24)

                return daysPassed < POPUP_DURATION_DAYS
            }
        }),
        {
            name: 'kibu-club-popup-storage',
        }
    )
)

export default useKibuClubPopupStore
